import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FaceActivatedAdd"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 3H19.5V0H18V3H15V4.5H18V7.5H19.5V4.5H22.5V3ZM20.865 10.5C21.4948 14.2257 19.7302 17.9481 16.4474 19.8192C13.1646 21.6902 9.06262 21.3114 6.17792 18.8709C3.29322 16.4304 2.24013 12.4478 3.54147 8.90042C4.8428 5.353 8.22142 2.99617 12 3V1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.4942 11.4979 22.4541 10.9967 22.38 10.5H20.865ZM6.75 10.125C6.75 9.08945 7.58947 8.24998 8.625 8.24998C9.12351 8.24594 9.60277 8.44219 9.95528 8.7947C10.3078 9.14721 10.504 9.62647 10.5 10.125C10.5 11.1605 9.66053 12 8.625 12C7.58947 12 6.75 11.1605 6.75 10.125ZM15.375 8.24998C14.3395 8.24998 13.5 9.08945 13.5 10.125C13.5 11.1605 14.3395 12 15.375 12C16.4105 12 17.25 11.1605 17.25 10.125C17.254 9.62647 17.0578 9.14721 16.7053 8.7947C16.3528 8.44219 15.8735 8.24594 15.375 8.24998ZM12 17.9964C9.84323 17.9964 7.84691 16.857 6.75 15H17.25C16.1531 16.857 14.1568 17.9964 12 17.9964Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FaceActivatedAdd.vue"]]);
